import { AppName, ProfileBaseItemType, ProfileVersion } from '../../../types'
import { isDev } from '../../version'
import {
  consentFormTab,
  filesTab,
  insuranceInfoTab,
  labsTab,
  patientSummaryTab,
  plansTab,
} from './shared'
import {
  PregnancyTab,
  ProfileTab,
  ProfileTabGroup,
  SubTab,
  SubTabGroup,
  V1ProfileTabName,
} from './types'

export const v1adminProfileTabNames: Array<V1ProfileTabName> = [
  'patient',
  'pregnancy',
  'payments',
  'auth',
  'claims',
  'files',
  // 'visits',
]

export const v1practiceProfileTabNames: Array<V1ProfileTabName> = [
  'patient',
  'pregnancy',
  'files',
  // 'visits',
]

export const profileBaseItemTypes: Array<ProfileBaseItemType> = [
  'patients',
  'pregnancies',
  'claims',
  // 'visits',
]

const assessmentTab: PregnancyTab = {
  path: 'assessment',
  name: 'Assessment',
}

const questionnaireTab: PregnancyTab = {
  path: 'questionnaire',
  name: 'Questionnaire',
}

const signOnInfoTab: PregnancyTab = {
  path: 'sign-on',
  name: 'Sign On Info',
}
const paymentsTab: PregnancyTab = {
  path: 'payments',
  name: 'Payments',
}

const authorizationsTab: PregnancyTab = {
  path: 'authorizations',
  name: 'Authorizations',
}

export const pregnancyTab: ProfileTab = {
  path: 'pregnancy',
  name: 'Pregnancy',
}

const patientPregnancyTab: ProfileTab = {
  path: 'patient',
  name: 'Patient',
}

const claimsTab: ProfileTab = {
  path: 'claims',
  name: 'Claims',
}

const chartingTab: PregnancyTab = {
  path: 'charting',
  name: 'Charting',
}

export const chartingSubTabs: SubTab[] = [
  { path: 'prenatal', name: 'Prenatal Flow' },
  { path: 'labor', name: 'Labor' },
  { path: 'postpartum', name: 'Postpartum Flow' },
]

const getPregnancyTabs = (appName: AppName): Array<SubTab | SubTabGroup> => {
  const tabs: Array<SubTab | SubTabGroup> = []
  tabs.push(appName === 'app' ? assessmentTab : questionnaireTab)
  // tabs.push(appName === 'app' ? signOnInfoTab : summaryTab)
  if (appName === 'app') {
    tabs.push(signOnInfoTab)
    tabs.push(authorizationsTab)
  }
  // if (appName === 'providers-app') tabs.push(paymentsTab)
  tabs.push(paymentsTab)
  tabs.push(plansTab)
  return tabs
}

const getV1PregnancySubTabs = (appName: AppName): Array<SubTab> => {
  const tabs: Array<SubTab> = []
  tabs.push(appName === 'app' ? assessmentTab : questionnaireTab)
  tabs.push(appName === 'app' ? signOnInfoTab : assessmentTab)
  tabs.push(appName === 'app' ? plansTab : paymentsTab)
  return tabs
}

export const getV1PregnancyTabs = (appName: AppName): Array<SubTab | SubTabGroup> => {
  const tabs: Array<SubTab | SubTabGroup> = []
  tabs.push(appName === 'app' ? patientSummaryTab : patientPregnancyTab)
  tabs.push({
    name: appName === 'providers-app' ? 'Billing' : 'Pregnancy',
    path: appName === 'providers-app' ? 'billing' : 'pregnancy',
    children: getV1PregnancySubTabs(appName),
  })
  tabs.push(insuranceInfoTab)
  if (appName === 'app') {
    tabs.push(paymentsTab)
    tabs.push(authorizationsTab)
    tabs.push(claimsTab)
  }

  if (isDev) {
    tabs.push({
      name: 'Charting',
      path: 'charting',
      children: chartingSubTabs,
    })
    tabs.push(labsTab)
  }
  tabs.push(filesTab)
  // tabs.push(visitsTab)
  tabs.push(consentFormTab)
  return tabs
}

export const getPregnancyTab = (
  appName: AppName,
  profileVersion: ProfileVersion,
): ProfileTabGroup => ({
  path: 'pregnancy',
  // name: appName === 'app' ? 'Assessment' : 'Billing / Insurance',
  name: 'Pregnancy',
  children: profileVersion === 'v1' ? getV1PregnancyTabs(appName) : getPregnancyTabs(appName),
})

export const getV2PregnancyTabs = (appName: AppName, pregnancyId?: string): Array<SubTab> => {
  const tabs: Array<SubTab> = []
  tabs.push(patientSummaryTab)
  const entity = pregnancyId ? { type: 'pregnancy', id: pregnancyId } : null
  if (appName === 'app') tabs.push(assessmentTab)
  tabs.push(signOnInfoTab)
  tabs.push(plansTab)
  tabs.push(filesTab)
  tabs.push(chartingTab)
  if (isDev) tabs.push(labsTab)
  return entity ? tabs.map(tab => ({ ...tab, entity })) : tabs
}

export const getV2PregnancyTab = (appName: AppName): ProfileTabGroup => ({
  name: 'Pregnancy',
  path: 'pregnancy',
  children: getV2PregnancyTabs(appName),
})
